import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./SrilaPrabhupada.css";

const SrilaPrabhupada = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="prabhupada-wrapper">
      <div className="prabhupada-hero">
        <div className="prabhupada-text" data-aos="fade-right">
          <h1>A. C. Bhaktivedanta Swami Srila Prabhupada</h1>
        </div>
      </div>
      <div className="prabhupada-bio" data-aos="fade-up">
        <p>
          <strong>His Divine Grace A. C. Bhaktivedanta Swami Prabhupada </strong> was born in 1896 in Calcutta, India. He first met his spiritual master, Srila Bhaktisiddhanta Sarasvati Gosvami, in Calcutta in 1922. Eleven years later (1933) at Allahabad, he became his formally initiated disciple.
        </p>
        <p>
          At their first meeting, in 1922, Srila Bhaktisiddhanta Sarasvati Thakura requested Srila Prabhupada to broadcast Vedic knowledge through the English language. In 1965, when he first arrived by freighter in New York City, Srila Prabhupada was practically penniless. It was after almost a year of great difficulty that he established the International Society for Krishna Consciousness in July 1966. Under his careful guidance, the Society has grown within a decade to a worldwide confederation of almost one hundred asramas, schools, temples, institutes, and farm communities.

        </p>
        <p>
          Srila Prabhupada’s most significant contribution, however, is his books. Highly respected by the academic community for their authoritativeness, depth, and clarity, they are used as standard textbooks in numerous college courses. His writings have been translated into eleven languages. The Bhaktivedanta Book Trust, established in 1972 exclusively to publish the works of His Divine Grace, has thus become the world’s largest publisher of books in the field of Indian religion and philosophy.

        </p>
        <p>
          In the last ten years of his life, in spite of his advanced age, Srila Prabhupada circled the globe twelve times on lecture tours that have taken him to six continents. In spite of such a vigorous schedule, Srila Prabhupada continued to write prolifically. His writings constitute a veritable library of Vedic philosophy, religion, literature, and culture.

        </p>
      </div>
    </div>
  );
};

export default SrilaPrabhupada;
